import React, { Fragment } from "react";
import FormControl from "@material-ui/core/FormControl";
import { InputLabel, MenuItem } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import { useAudiences } from "../vocabularyServices";
import { Skeleton } from "@material-ui/lab";

const AudienceSelect = props => {
  const { onChange, label = "Audience", value, valueFormat = "name" } = props;
  const audiences = useAudiences();

  return (
    <Fragment>
      {audiences.isLoading ? (
        <Skeleton variant="text" />
      ) : (
        <FormControl fullWidth>
          <InputLabel htmlFor="content-audience">{label}</InputLabel>
          <Select
            value={value || ""}
            onChange={onChange}
            inputProps={{
              name: "media-audience",
              id: "media-audience",
            }}
          >
            {audiences.data.map(aud => {
              return (
                <MenuItem
                  value={valueFormat === "name" ? aud.name : aud}
                  key={aud.name}
                >
                  {aud.display}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      )}
    </Fragment>
  );
};

export default AudienceSelect;
